// @flow
import React, { useState } from 'react';
import { Button } from '@finect/tabular-core/Button';
import { MessageCircle } from '@finect/tabular-icons/messageCircle';
import { LeadPillModal } from './LeadPillModal';
import { Banner, BannerIcon, BannerText, BannerTitle, BannerSubtitle, BannerAction } from './partials';

/**
 * Banner de captación de lead de asesor para la cabecera del perfil (`/usuario/{alias}`),
 * versión desktop. Reutiliza el lenguaje visual de la antigua tarjeta del sidebar (fondo de
 * marca, icono, título y CTA) pero en formato horizontal compacto para no empujar el
 * contenido. Al pulsar el botón abre la píldora `advisers-leads` en un modal; el iframe no se
 * carga hasta que el usuario muestra intención (mejor CWV) y el lead queda rastreado con
 * `Pagina_referencia = ` la URL del perfil.
 *
 * Solo se muestra en ≥ miniDesktop (CSS); en móvil/tablet la captación la cubre
 * `ProfileLeadBar`.
 */
export const ProfileLeadBanner = () => {
  const [open, setOpen] = useState(false);

  return (
    <Banner>
      <BannerIcon>
        <MessageCircle color="#fff" size="22" />
      </BannerIcon>

      <BannerText>
        <BannerTitle>Encuentra un asesor financiero y saca el máximo partido a tu dinero</BannerTitle>
        <BannerSubtitle>Gratis y sin compromiso, encontrarás a los asesores que mejor encajen con tu perfil.</BannerSubtitle>
      </BannerText>

      <BannerAction>
        <Button color="secondary" variant="medium" width="auto" data-fi-event="perfilAsesor-buscarAsesor" onClick={() => setOpen(true)}>
          Buscar un asesor financiero
        </Button>
      </BannerAction>

      {open ? <LeadPillModal onClose={() => setOpen(false)} /> : null}
    </Banner>
  );
};
